module.exports = __webpack_public_path__ + "static/media/img121_R.aa4945fd.jpg";